<app-lead-note-item
  [policies]="policies"
  [leadId]="leadId"
  [isExpanded]="true"
  [statuses]="noteStatuses"
  [totalStatuses]="totalNotesStatuses"
  [note]="note"
  [keyword]="keyword"
  (onRefresh)="fetchLeadNotes()"></app-lead-note-item>
